export default {
  zh: {
    affiliateProgram: 'Plex加速器联盟推广计划',
    memberInfo: '加入我们成为 Plex加速器的联盟推广成员，获取高额佣金奖励。',
    becomeMember: '成为联盟推广成员',
    advertise: '您只需动动手指，将邀请码或者联盟推广链接发送给您的好友，邀请他使用Plex加速器。好友充值成功，您将获得￥2.8现金奖励。无奖励上限，无需任何成本。'
  },
  en: {
    affiliateProgram: 'PlexVPN Affiliate Program',
    memberInfo: 'Become a PlexVPN affiliate and start to earn money by promoting the higher speed, ultra secure and easy-to-use VPN.',
    becomeMember: 'Become an Affiliate',
    advertise: 'You only need to send your unique affiliate code or affiliate link to your friends, and invite them to use PlexVPN. For every friend who successfully purchases a package, you’ll get $0.45 as commission. There are no limits to commission, the more friends you invite, the more reward you’ll get.'
  }
}



// WEBPACK FOOTER //
// ./src/views/affiliateProgram/lang.js